export default function Style(){
  return (
    <style>
      { `
    
.client-logo {
    
  display: flex !important;
  justify-content: center;
  align-items: center;
  


}

.client-logo img {
 

}
.img-responsive{
  border-radius: 0 !important;
  width: 80% !important;
}
.client-logo img:hover {
opacity: 1.0;
  filter: alpha(opacity=100);
}  

/* Arrows */
.clients-brand-carousel .left-arrow{
  left: 35px;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}
.clients-brand-carousel .right-arrow {
  right: 35px ;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}
 
 
.clients-brand-carousel .left-arrow .right-arrow {
   font-size: 0;
   line-height: 0;
   position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
      -webkit-transform: translate(0, -50%);
      -moz-transform: translate(0, -50%);
      transform: translate(0, -50%);
      cursor: pointer;
      color: transparent;
      border: none;
      outline: none;
      background: transparent;
}
.clients-brand-carousel .left-arrow:hover {
  color: black!important;

}
.clients-brand-carousel .right-arrow:hover {
  color: black !important;

}

.clients-brand-carousel .slick-list .slick-track .slick-slide {
  width: auto !important;
  outline: none;
 
}
.clients-brand-carousel  {
  padding: 0 85px !important;
}
.clients-brand-carousel .slick-list .slick-track {
  display: flex !important;
}
 
@media only screen and (max-width: 370px) {
  .clients-brand-carousel .slick-list .slick-track .slick-slide {
    padding: 39px 0px;
  }

}
@media only screen and (max-width: 600px) {
  .clients-brand-carousel .slick-list .slick-track .slick-slide {
    padding: 39px 4px;
  }
  .clients-brand-carousel .left-arrow {
    left: 13px !important;
    color: black;
    outline: none;
    position: absolute;
    top: 43%;
    z-index: 1;
  }

  .clients-brand-carousel .right-arrow {
    right: 13px !important;
    color: black;
    outline: none;
    position: absolute;
    top: 43%;
    z-index: 1;
  }
  .clients-brand-carousel  {
    padding: 0 40px !important;
  }

  .clients-brand-carousel .left-arrow{
    left: -8px;
  }
}



@media only screen and (max-width: 1024px) {
  .clients-brand-carousel .slick-list .slick-track .slick-slide {
    padding: 39px 13px;
  }
}
@media only screen and (min-width: 1024px) {
  .clients-brand-carousel .slick-list .slick-track .slick-slide {
    padding: 39px 5px;
 }
}


.slick-dots li button:before {
  font-family: 'slick';
  font-size: 6px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: '' !important;
  text-align: center;
  opacity: .25;
  color: black;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
    ` }
    </style>
  );
}


